// @flow
import React, { Component } from 'react'
import Tooltip from '../Tooltip'
import styled, { type StyledComponent } from 'styled-components'
import { alertColor } from '../controls/colors'

const TriggerTextWrapper: StyledComponent<Object, any, any> = styled.div`
  cursor: pointer;
  ${({ inlineBlock }: Object) => (inlineBlock ? 'display: inline-block;' : '')};
  ${({ alert }: Object) =>
    alert ? `color: ${alertColor}; border-bottom: 1px dashed ${alertColor};` : ''};
  &:hover {
    opacity: 0.8;
  }
`

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  ${({ inlineBlock }: Object) => (inlineBlock ? 'display: inline-block;' : '')};
`

type Props = {|
  triggerText: any,
  isOpen: boolean,
  onChange?: Function,
  className?: string,
  alert?: boolean,
  inlineBlock?: boolean,
  children: any
|}

export default class ExpandingDropdown extends Component<Props> {
  render() {
    const { className, triggerText, isOpen, children, alert, inlineBlock } = this.props

    return (
      <Wrapper inlineBlock={inlineBlock} className={className}>
        <Tooltip
          isInteractive
          isOpen={isOpen}
          content={children}
          onClose={() => this.changed(false)}
        >
          <TriggerTextWrapper
            alert={alert}
            inlineBlock={inlineBlock}
            onClick={() => this.changed(true)}
          >
            {triggerText}
          </TriggerTextWrapper>
        </Tooltip>
      </Wrapper>
    )
  }

  changed(isOpen: boolean) {
    const { onChange } = this.props

    onChange && onChange(isOpen)
  }
}
